import{getDefaultExportFromCjs as r}from"./_commonjsHelpers.mjs";import{__require as o}from"../node_modules/warning/warning.mjs";var t=o();const i=r(t);export{i as default};
